import { NotificationsActive } from "@mui/icons-material";
import React from "react";

const Newsletter = () => {
  return (
    <section class="container">
      <div class="bg-secondary rounded-3 py-5 px-3 px-sm-4 px-lg-5 px-xl-0">
        <div class="row align-items-center py-lg-4">
          <div class="col-xl-5 col-md-6 offset-xl-1 mb-4 mb-md-0">
            <div class="d-flex align-items-center">
              <NotificationsActive
                sx={{ width: 74, height: 74, color: "#139595" }}
              />
              <div class="ps-3 ms-sm-3">
                <h2 class="h4 mb-0">
                  Subscribe to our newsletter to stay informed about latest
                  updates
                </h2>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-md-6">
            <div class="ps-lg-5 ms-xl-2">
              <form
                class="input-group input-group-lg needs-validation"
                novalidate
              >
                <input
                  type="email"
                  id="subscr-email"
                  class="form-control rounded-start ps-5"
                  placeholder="Your email"
                  required
                />
                <i class="bx bx-envelope fs-xl text-muted position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5"></i>
                <div class="invalid-tooltip position-absolute top-100 start-0">
                  Please provide a valid email address.
                </div>
                <button type="submit" class="btn btn-primary px-sm-4">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
